import { ofType } from "redux-observable";
import { of } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { GET_KEY_VALUE_STORE_BEGIN, logError, getKeyValueStoreSuccess } from "../actions";
export default function getKeyValueStore(action$, state$) {
    return action$.pipe(ofType(GET_KEY_VALUE_STORE_BEGIN), map(function() {
        var sd = state$.value.api && state$.value.api.getSuspendData() || {};
        return !state$.value.api ? logError({
            error: new Error("No LMS API found"),
            key: "no_api"
        }) : getKeyValueStoreSuccess({
            keyValueStore: sd.kv || {}
        });
    }), catchError(function(error) {
        return of(logError({
            error: error,
            key: "get_key_value_store"
        }));
    }));
}
